<template>
  <PageTemplate>
    <div class="row">
      <!--Notifications-->
      <div
        v-if="checkPermission('news')"
        class="col-xl-6 d-flex"
      >
        <v-card title="News">
          <template #header>
            <v-button
              to="/news"
              color="transparent"
              size="sm"
              @click="viewAll('/news')"
            >
              <v-icon type="show" />
              View More News
            </v-button>
          </template>
          <div class="news-card__body">
            <v-spinner v-if="newsLoading" />
            <v-table
              :table="news"
              is-reduced
            />
          </div>
        </v-card>
      </div>
      <div
        class="col-xl-6 d-flex"
      >
        <v-card title="Notifications">
          <template #header>
            <v-button
              to="/notifications"
              color="transparent"
              size="sm"
              @click="viewAll('/notifications')"
            >
              <v-icon type="show" />
              View Notifications
            </v-button>
          </template>
          <v-notification
            v-for="(notification, index) in recentNotification"
            :key="index"
            :text="notification.title"
            :link="notification.data.data.url"
            @click="resolveNotification(notification)"
          />
          <v-button-group
            v-if="Object.keys(notifications).length > 0"
            is-right
          >
            <v-button
              color="transparent"
              size="sm"
              @click="removeAllNotifications()"
            >
              <v-icon type="trash" />
              Clear all
            </v-button>
          </v-button-group>
        </v-card>
      </div>
      <!--Upcoming meetings-->
      <div
        v-if="checkPermission('calendar')"
        class="col-xl-6 d-flex"
      >
        <v-card title="Upcoming meetings">
          <template #header>
            <v-button
              to="/calendar"
              color="transparent"
              size="sm"
              @click="viewAll('/calendar')"
            >
              <v-icon type="show" />
              View Calendar
            </v-button>
          </template>
          <v-notification
            v-for="(event, index) in upcomingEvents"
            :key="index"
            icon="clock"
            :text="event.title"
            :date="event.formatDate"
            :time="event.formatTime"
            :all-day="event.allDay"
            style="cursor:pointer;"
            @click="navigateToUpComingMeeting(event)"
          />
        </v-card>
      </div>
      <!--recent meeting documents-->
      <div
        v-if="checkPermission('meeting-documents')"
        class="col-xl-6 d-flex"
      >
        <v-card title="Recent Documents">
          <template #header>
            <v-button
              to="/meeting-documents"
              color="transparent"
              size="sm"
              @click="viewAll('/meeting-documents')"
            >
              <v-icon type="show" />
              View All Documents
            </v-button>
          </template>
          <v-table
            :table="recentDocumentTable"
            is-reduced
            @showDoc="show"
          />
        </v-card>
      </div>
      <!--jobs-->
      <div
        v-if="checkPermission('jobs')"
        class="col-12 d-flex"
      >
        <v-card title="Jobs">
          <template #header>
            <v-button
              to="/jobs"
              color="transparent"
              size="sm"
              @click="viewAll('/jobs')"
            >
              <v-icon type="show" />
              View All Jobs
            </v-button>
          </template>
          <v-table
            :table="jobs"
            is-reduced
          />
        </v-card>
      </div>
      <!--invoices-->
      <div
        v-if="checkPermission('invoices')"
        class="col-xl-6 d-flex"
      >
        <v-card title="Invoices to be paid">
          <template #header>
            <v-button
              to="/jobs"
              color="transparent"
              size="sm"
              @click="viewAll('/invoices')"
            >
              <v-icon type="show" />
              View All Invoices
            </v-button>
          </template>
          <v-table
            :table="invoices"
            is-reduced
          />
        </v-card>
      </div>
      <!--publications-->
      <div
        v-if="checkPermission('publications')"
        class="col-xl-6 d-flex"
      >
        <v-card title="Recent Publications">
          <template #header>
            <v-button
              to="/publications"
              color="transparent"
              size="sm"
              @click="viewAll('/publications')"
            >
              <v-icon type="show" />
              View All Publications
            </v-button>
          </template>
          <v-table
            :table="publications"
            is-reduced
            @showDoc="show"
          />
        </v-card>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Notification from "@/atoms/Notification";
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";
  import Spinner from "@/atoms/Spinner";
  import {mapState, mapActions} from "vuex";
  import PageTemplate from "@/templates/Page";
  import {
    columnSort,
    dateSort_ddmmyyyy,
    buildBreadCrumb,
    amountSort
  } from "../common/tableFunctions";
  import constants from "@/common/constants";
  import router from "../router";
    import TokenService from "../common/tokenService";
  import {
    GET_EVENTS,
    GET_INVOICES,
    GET_RECENT_PUBLICATIONS,
    GET_USER_JOBS,
    GET_USER_NOTIFICATION,
    GET_NEWS,
    UPDATE_NOTIFICATION
  } from "../store/actions.type";
  import {formatDate} from "@/common/formatting";
  import routes from "@/common/routes";
  import moment from 'moment';
  import {notificationResolver} from "../common/notificationUtils";
  import { filePath } from "@/common/documentFunctions";

  export default {
    name: "Dashboard",
    components: {
      'v-card': Card,
      'v-button': Button,
      'v-table': Table,
      'v-icon': Icon,
      'v-button-group': ButtonGroup,
      'v-notification': Notification,
      'v-spinner': Spinner,
      PageTemplate
    },
    data() {
      return {
        news: {
          columns: [
            {
              label: 'Title',
              field: 'title',
              sortFn: columnSort,
              thClass: 'sortable',
              link: true
            },
            {
              label: 'Category',
              field: 'category',
              sortFn: columnSort,
              thClass: 'sortable'
            },
            {
              label: 'Date',
              field: 'date',
              sortFn: dateSort_ddmmyyyy,
              thClass: 'sortable'
            }
          ],
          rows: []
        },
        jobs: {
          columns: [
            {
              label: 'Job ID',
              field: 'job_number',
              link: true,
              sortFn: columnSort,
              thClass: 'sortable'
            },
            {
              label: 'Job Type',
              field: 'type',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Visit Date',
              field: 'visit_date',
              sortFn: dateSort_ddmmyyyy,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Site Name',
              field: 'site',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Suburb',
              field: 'suburb',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'State',
              field: 'state',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Site ID',
              field: 'site_id',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Status',
              field: 'status',
              badge: true,
              sortFn: columnSort,
              thClass: 'sortable shrink-cell',
              tdClass: 'shrink-cell'
            },
          ],
          rows: []
        },
        invoices: {
          columns: [
            {
              label: 'Invoice ID',
              field: 'invoice_id',
              sortFn: columnSort,
              thClass: 'sortable'
            },
            {
              label: 'Invoice Type',
              field: 'type',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Transaction Date',
              field: 'dueBy',
              sortFn: dateSort_ddmmyyyy,
              thClass: 'sortable'
            },
            {
              label: 'Amount',
              field: 'amount_due',
              bold: true,
              sortFn: amountSort,
              thClass: 'sortable shrink-cell text--right',
              tdClass: 'shrink-cell text--right'
            },
          ],
          rows: []
        },
        publications: {
          columns: [
            {
              label: 'Name',
              field: 'name',
              sortFn: columnSort,
              thClass: 'sortable'
            },
            {
              label: 'File Path',
              field: 'filePath',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Updated',
              field: 'updated',
              sortFn: dateSort_ddmmyyyy,
              thClass: 'sortable shrink-cell',
            },
            {
              label: '',
              field: 'actions',
              sortable: false,
              actions: 'view',
              thClass: 'shrink-cell',
              tdClass: 'no-wrap'
            },
          ],
          rows: []
        },
        upcomingEvents: [],
        recentNotification: {},
        recentDocumentTable: {
          columns: [
            {
              label: 'Name',
              field: 'name',
              sortFn: columnSort,
              thClass: 'sortable'
            },
            {
              label: 'File Path',
              field: 'filePath',
              sortFn: columnSort,
              thClass: 'sortable d-none d-sm-table-cell',
              tdClass: 'd-none d-sm-table-cell'
            },
            {
              label: 'Updated',
              field: 'dateUpdated',
              sortFn: dateSort_ddmmyyyy,
              thClass: 'sortable'
            },
            {
              label: '',
              field: 'actions',
              sortable: false,
              actions: 'view',
              thClass: 'shrink-cell',
              tdClass: 'no-wrap'
            },
          ],
          rows: [],
          totalRecords: 0,
          perPage: [
            {
              label: "5",
              value: 5
            },
            {
              label: "10",
              value: 10
            }
          ]
        }
      };
    },
    computed: {
      ...mapState({
        events: state => state.committees.events,
        notifications: state => state.notification.latestNotifications,
        newsRow: state => state.news.news,
        newsLoading: state => state.news.loading,
        jobsRow: state => state.job.jobs,
        invoiceRow: state => state.invoices.invoices.outstandingInvoices,
        recentDocumentTableRow: state => state.meetingDocuments.recentDocumentTableRow,
      }),
      selectedCommittee() {
        return this.$store.getters.getSelectedCommittee;
      },
    },
    watch: {
      recentDocumentTableRow: {
        handler(val) {
          this.recentDocumentTable.rows = val.slice(0, 5);
        }
      },
      notifications: {
        handler: function (val) {
          this.recentNotification = Object.keys(val).slice(0, 5).reduce((result, key) => {
            result[key] = val[key];
            return result;
          }, {});
        }
      },
      newsRow: {
        handler: function (val) {
          if (val && Array.isArray(val)) {
            this.news.rows = val.slice(0, 3);
          } else {
            this.news.rows = [];
          }
        },
        immediate: true
      },
      jobsRow: {
        handler: function (val) {
          this.jobs.rows = val.slice(0, 5);
        }
      },
      invoiceRow: {
        handler: function (val) {
          this.invoices.rows = val.slice(0, 5);
        }
      },
      selectedCommittee: {
        handler(val) {
          if (localStorage.getItem(constants.CURRENT_ROLE) !== constants.NATA_ROLE_CM) {
            return;
          }
          this.getEvents(val);
          this.getRecentDocuments(val);
          this.updateNotification();
        }
      },
      events: {
        handler: function (val) {
          /**
           * Only return upcoming events with required format,(start >= Now)
           */
          this.upcomingEvents = this.events.filter(e => formatDate(e.start, 'YYYY-MM-DD HH:mm:ss') >= moment.utc().local().format('YYYY-MM-DD HH:mm:ss')).slice(0, 5);
        }
      },
    },
    mounted() {
      if(TokenService.getCurrentRole() === constants.NATA_ROLE_ADMIN || TokenService.getCurrentRole() === constants.NATA_ROLE_TA_ADMIN) {
        this.$router.push(routes.ADMIN.OUTSTANDING_ACTIVITIES);
        return;
      }
      this.updateBreadCrumb();
      this.updateNotification();
      this.getNews();
      this.getUserJobs();
      this.getInvoices();
      this.getPublication();
      this.getEvents(this.selectedCommittee);
      this.getRecentDocuments(this.selectedCommittee);
    },
    methods: {
      ...mapActions([
        'getRecentDocuments',
        'showDocument',
        'downloadDocument'
      ]),
      resolveNotification(notification) {
        notificationResolver(notification);
      },
      removeAllNotifications() {
        var ids = []
        for (let [key, value] of Object.entries(this.notifications)) {
          ids.push(value.id)
        }
        this.$store.dispatch(UPDATE_NOTIFICATION, [ids, 'delete']).then(response => {
          if (response.success) {
            this.updateNotification()
          }
        });
        return true;
      },
      removeNotification(index) {
        this.$delete(this.notifications, index);
      },
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      updateNotification: function () {
        this.$store.dispatch(GET_USER_NOTIFICATION, 20);
      },
      getUserJobs() {
        if (this.checkPermission('jobs')) {
          this.$store.dispatch(GET_USER_JOBS);
        }
      },
      getNews() {
        if (this.checkPermission('news')) {
          this.$store.dispatch(GET_NEWS, { limit: 3 });
        }
      },
      getInvoices: function () {
        if (localStorage.getItem(constants.CURRENT_ROLE) === constants.NATA_ROLE_AR) {
          this.$store.dispatch(GET_INVOICES, localStorage.getItem(constants.CURRENT_ROLE));
        }
      },
      getPublication: function () {
        this.$store.dispatch(GET_RECENT_PUBLICATIONS).then(response => {
          let publications = JSON.parse(JSON.stringify(response));
          let transformed = [];
          if (publications.length > 0) {
            transformed = publications.map(publication => {
              return {
                'name': {"value": publication.name},
                'updated': {"value": formatDate(publication.updated_at, constants.DD_MM_YYYY)},
                'filePath': {"value": filePath(publication.uri)},
                'actions': [{link: `/publications/${publication.id}`, icon: 'show'}]
              }
            });
          }
          this.publications.rows = transformed.slice(0, 5);
        });
      },
      getEvents(val) {
        if (val !== null) {
          this.$store.dispatch(GET_EVENTS, val);
        }
      },
      viewAll(route) {
        this.$router.push(route);
      },
      checkPermission(route) {
        if (route === 'news') {
          let permissions = [constants.NATA_ROLE_AR, constants.NATA_ROLE_TA];
          return permissions.indexOf(localStorage.getItem(constants.CURRENT_ROLE)) !== -1;
        } else if (route === 'invoices') {
          let permissions = [constants.NATA_ROLE_AR];
          return permissions.indexOf(localStorage.getItem(constants.CURRENT_ROLE)) !== -1;
        } else if (route === 'jobs') {
          let permissions = [constants.NATA_ROLE_AR, constants.NATA_ROLE_TA];
          return permissions.indexOf(localStorage.getItem(constants.CURRENT_ROLE)) !== -1;
        } else if (route === 'publications') {
          let permissions = [constants.NATA_ROLE_AR, constants.NATA_ROLE_TA, constants.NATA_ROLE_CM];
          return permissions.indexOf(localStorage.getItem(constants.CURRENT_ROLE)) !== -1;
        } else if (route === 'calendar' || route === 'meeting-documents') {
          let permissions = [constants.NATA_ROLE_CM];
          return permissions.indexOf(localStorage.getItem(constants.CURRENT_ROLE)) !== -1;
        }
      },
      show(link) {
        this.$store.state.auth.isLoading = true;
        // If Microsoft Edge below 50 version
        if(window.navigator && window.navigator.msSaveOrOpenBlob) {
          this.downloadDocument(link).then(res => {
            this.$store.state.auth.isLoading = false;
          }).catch(err => {
            this.$notify({
                  title: 'Error',
                  text: err.message,
                  type: 'error'
                });
          }).finally(() => {
            this.$store.state.auth.isLoading = false;
          });
          return;
        }
        this.showDocument(link).then(response => {
          window.open(response, '_blank');
          this.$store.state.auth.isLoading = false;
        })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: error,
              type: 'error'
            }).finally(() => {
            this.$store.state.auth.isLoading = false;
          });
          })
      },
      navigateToUpComingMeeting(event) {
        router.push('/calendar/' + event.start);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .news-card__body {
    position: relative;
    min-height: 120px;
  }
</style>
